import { useEffect } from 'react';

/** Auto-clears a flash message after `ms`. Cleans up on unmount or when
 *  the flash changes, preventing setState-on-unmounted-component noise
 *  (a real risk under React 18 StrictMode). Takes the setter directly —
 *  React guarantees stable identity for useState setters, so the effect
 *  dep array stays stable across renders instead of churning a fresh
 *  timer on every render. */
export function useFlashTimeout(
  flash: string | null,
  setFlash: (v: null) => void,
  ms = 5000,
): void {
  useEffect(() => {
    if (!flash) return;
    const id = globalThis.setTimeout(() => setFlash(null), ms);
    return () => globalThis.clearTimeout(id);
  }, [flash, setFlash, ms]);
}
